import { render } from "./SurveyLanguage.vue?vue&type=template&id=0e32f804"
import script from "./SurveyLanguage.vue?vue&type=script&lang=ts"
export * from "./SurveyLanguage.vue?vue&type=script&lang=ts"
script.render = render

export default script